import { Button, Col, Row } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RootState } from '../../../store';
import { setIsEasyDischargeCase, setPayerNotConfig, updateSelectedBtnType, updateSelectedDetail } from '../../../store/actions/inPatientAction';
import { setMobileOnScreen, setToggleClick } from '../../../store/actions/newAdmissionAction';
import { lockUnlockOrDeleteDraft } from '../../../store/actions/savedDraftAction';
import { updateIsOnNotificationflow } from '../../../store/actions/utilAction';
import { ApplicationDetailModel } from '../../../store/models/applicationDetailModel';
import { MailboxType } from '../../../store/models/mailBoxModel';
import { base64UrlEncode, canActivate, centeredNotification } from '../../../utils/utility';
import { authFeatureConstants, CANCELLATION_STATUS_ID, GUTTOR_SPACE_SMALL, RPA_PAYER_NOT_CONFIGURED_ERR } from '../../constants/commonConstants';
import { actions, ctaActionNames, NON_CONFIGURED_PAYERS_BLOCK_POST_PRE_AUTH } from '../../constants/crmConstants';
import useGetPasswordExpireNotification from '../../hooks/useGetPasswordExpireNotification';
import { Payer } from '../../models/payer.model';
import { customGTMEvent, isReconsiderEnabled } from '../../../modules/crm/inPatient/service/crmUtils';
import { setInpatientReconsiderClicked } from '../../../store/actions/claimDetailsAction';
import { isEmpty } from 'lodash';
import CONTROL_CONFIG_BASED_ON_PAYER from '../../../config/formControlConfig';

export interface IInPatientListActions {
  text: any;
  record: any;
  index: any;
  enablers: any;
}
const InPatientListActions = ({ index, text, record, enablers }: IInPatientListActions): ReactElement => {
  const {
    isCancelable, isEnhance, isCashlessSubmission,
    isQuery, isFreeEdit, islocked = false, isDraft, isClaimSubmissionDisabled, isEasyDischarge, isDischarge, isReconsider,
    isEasyDischargeQuery, isDischargeContestCTA } = enablers;
  const history = useHistory();
  const dispatch = useDispatch();
  const [setShowMessage, setIsShowMessage] = useState(false);
  const getNotification = useGetPasswordExpireNotification();
  const allPayers = useSelector((state: RootState): Payer[] => state?.payerList?.allPayers || []);
  const { hospitalConfiguration: emailConfiguration = {} as any } = useSelector((state: RootState): MailboxType => state?.mailBox || {});
  const { passwordExpire } = emailConfiguration || {};
  const redirectionDetails = allPayers?.filter((payerValue: Payer): boolean => payerValue?.id ===
    record?.payerId)?.[0]?.payerReDirectionDtails;
  const { payerNotConfig, selectedDetail, selectedBtnType,
    isDraftBtnClicked } = useSelector((state: RootState): any => state.selectedInPatientDetail);
  const appdetails = useSelector(
    (state: RootState): ApplicationDetailModel => state.applicationDetail,
  );
  const { claimDetails } =
    useSelector((state: RootState): any => state.admissionDetails);
  const isEasyDischargeEnabled = appdetails.getIsEasyDischargeEnabled();
  const matchedPayer = allPayers?.find(
    (payerItem: Payer): any => payerItem?.id === record?.payerId,
  );
  const cancelActionCTA = JSON.parse(matchedPayer?.actionProperties || '{}')?.[CANCELLATION_STATUS_ID]?.CTAName;
  const payerConfig = CONTROL_CONFIG_BASED_ON_PAYER[record.payerName];
  const payerConfigValues = Object.values(payerConfig || '');
  const ARTEMIS_PAYER = payerConfigValues.some(({type}: any): boolean => type === 'ARTEMIS');
  const reconsiderBtnValidation = payerConfigValues?.some((config: any): boolean => Boolean(config?.reconsiderBtnValidation));
  const isOrionIntegrationEnabledProvider = appdetails.getIsOrionIntegrationEnabled();
  const disableReconsider = ARTEMIS_PAYER && isOrionIntegrationEnabledProvider;

  const onChangeSwitch = (): any => {
    dispatch(setToggleClick(true));
    dispatch(setMobileOnScreen(true));
  };

  // for rpa disbaled payers
  useEffect((): any => {
    if (payerNotConfig && selectedBtnType && setShowMessage && !isEmpty(allPayers)) {
      centeredNotification(RPA_PAYER_NOT_CONFIGURED_ERR);
      return history.push('/claims/in-patient');
    }
  }, [selectedDetail, selectedBtnType]);

  const onButtonClick = (event: any, btnType: any): any => {
    setIsShowMessage(true);
    event.preventDefault();
    event.stopPropagation();
    if (btnType !== 'REDIRECT' || btnType !== 'DRAFT_DELETE') {
      dispatch(updateSelectedDetail(record));
    }
    if (isEmpty(allPayers)) { // to notify user that no action cannot be performed as there is no configured payer
      centeredNotification(NON_CONFIGURED_PAYERS_BLOCK_POST_PRE_AUTH, 'info');
    }
    let showModal = true;
    const { payerClaimNo: claimNo, hospActionId, payerId, productCode, draftId, providerId } = record;
    const payerClaimNo = base64UrlEncode(claimNo);
    const uniquePayerId = `${payerId}${productCode || ''}`;
    const selectedPayer = allPayers.find((ele: Payer): boolean => ele?.uniqueIdentifier === uniquePayerId);
    if (!selectedPayer) {
      showModal = false;
      dispatch(setPayerNotConfig(true));
      dispatch(updateSelectedBtnType(btnType));
    } else {
      dispatch(setPayerNotConfig(false));
    }
    if (passwordExpire && record?.payerType === 'MultiPayer') {
      return centeredNotification('Password expired', 'error', getNotification);
    }
    if (showModal) {
      const claimDetailsRoute = `${payerClaimNo}/${hospActionId}/${payerId}/${uniquePayerId}/${productCode}/${btnType === 'CANCEL' ? true : false}/${providerId}`;
      switch (btnType) {
        case actions.CASHLESSSUMBIT:
          history.push(`/claims/in-patient/detail/${base64UrlEncode(`${payerClaimNo}/${hospActionId}/${payerId}/${uniquePayerId}/${productCode}/${providerId}`)}/edit/${base64UrlEncode(actions.CASHLESSSUMBIT)}`);
          break;
        case 'EDIT':
          history.push(`/claims/in-patient/detail/${base64UrlEncode(`${payerClaimNo}/${hospActionId}/${payerId}/${uniquePayerId}/${productCode}/${providerId}`)}/edit`);
          dispatch(updateIsOnNotificationflow(false));
          break;
        case 'DISCHARGE':
          history.push(`/claims/in-patient/detail/${base64UrlEncode(`${payerClaimNo}/${hospActionId}/${payerId}/${uniquePayerId}/${productCode}/${providerId}`)}/discharge`);
          dispatch(updateIsOnNotificationflow(false));
          break;
        case 'RECONSIDER':
          dispatch(setInpatientReconsiderClicked(true));
          history.push(`/claims/in-patient/detail/${base64UrlEncode(`${payerClaimNo}/${hospActionId}/${payerId}/${uniquePayerId}/${productCode}/${providerId}`)}`);
          break;
        case 'CANCEL':
          history.push(`/claims/in-patient/detail/${base64UrlEncode(claimDetailsRoute)}/cancel/${base64UrlEncode(actions.CANCEL)}`);
          break;
        case 'CORP_EDIT':
          history.push(`/claims/in-patient/detail/${base64UrlEncode(`${payerClaimNo}/${hospActionId}/${payerId}/${uniquePayerId}/${productCode}/${providerId}`)}/edit/${base64UrlEncode(actions.EDIT)}`);
          break;
        case 'DRAFT_DELETE':
          dispatch(lockUnlockOrDeleteDraft({ draftId, shouldDelete: true }));
          break;
        case 'REDIRECT':
          window.open(JSON.parse(redirectionDetails || '{}').link, '_blank');
          break;
        default:
          history.push('/');
      }
    }
  };

  return (
    <React.Fragment>
      {
        isClaimSubmissionDisabled ? (
          <Row gutter={GUTTOR_SPACE_SMALL}>
            <Col>
              <Button
                type="primary"
                onClick={(event: any): any => onButtonClick(event, 'REDIRECT')}
                size="small">
                {JSON.parse(redirectionDetails || '{}').lable}
              </Button>
            </Col>
          </Row>
        ) : (
          <Row gutter={GUTTOR_SPACE_SMALL}>
            {
              isEnhance || isQuery ||
                ((process.env.REACT_APP_IS_EASY_DISCHARGE === 'true') && isEasyDischargeEnabled && isEasyDischargeQuery) ?
                <Col>
                  <Button data-testid="enhance-action" type="primary"
                    onClick={(event: any): void => {
                      onButtonClick(event, 'EDIT');

                      if (isQuery || isEasyDischargeQuery) {
                        customGTMEvent({
                          event: 'Click on Query Response',
                        });
                      } else {
                        customGTMEvent({
                          event: 'Click on Enhance',
                        });
                      }
                    }}>
                    {isQuery || isEasyDischargeQuery ? 'Query Response' : 'Enhance'}
                  </Button>
                </Col> : null
            }
            {isReconsider && isReconsiderEnabled(claimDetails, reconsiderBtnValidation, disableReconsider) ? (
              <Button
                data-testid="reconsider"
                className="mr-10"
                type="primary"
                onClick={(event: any): void => onButtonClick(event, 'RECONSIDER')}
              >
                {ctaActionNames.RECONSIDER}
              </Button>
            ) : null}
            {
              process.env.REACT_APP_IS_EASY_DISCHARGE === 'true' && isEasyDischargeEnabled && isEasyDischarge ?
                <Col>
                  <Button data-testid="enhance-action" type="primary" // isEasyDischarge button added for HDFC (IPP-4588)
                    onClick={(event: any): void => {
                      dispatch(setIsEasyDischargeCase(true));
                      onButtonClick(event, 'EDIT'); // change in CTA from Easy Discharge to Early Discharge (IPP-4803)
                      customGTMEvent({
                        event: 'Click on Early Discharge',
                      });
                    }}>
                    {ctaActionNames.EARLYDISCHARGE}
                  </Button>
                </Col> : null
            }
            {
              isCashlessSubmission && (!appdetails?.getIsPreAuthClaimViewEnabled()) &&
              <Col>
                <Button type="primary" data-testid="settlement-action"
                  onClick={(event: any): void => onButtonClick(event, actions.CASHLESSSUMBIT)}>
                  {ctaActionNames.SETTLEMENT}
                </Button>
              </Col>
            }
            {
              (isDischarge || isDischargeContestCTA) &&
              <Col>
                <Button data-testid="enhance-action" type="primary"
                  onClick={(event: any): void => onButtonClick(event, 'DISCHARGE')}>
                  {isDischarge ? ctaActionNames.DISCHARGE : ctaActionNames.DISCHARGECONTEST}
                </Button>
              </Col>
            }
            {
              isCancelable &&
              <Col>
                <Button data-testid="cancel-action" type="primary"
                  onClick={(event: any): void => onButtonClick(event, 'CANCEL')}>
                  {cancelActionCTA || ctaActionNames.CANCEL}
                </Button>
              </Col>
            }
            {
              process.env.REACT_APP_HEALTH_LOCKER_ENABLED === 'true' && !isDraftBtnClicked &&
              <Col>
                <Button type="primary" data-testid="activate-healthlocker"
                  onClick={onChangeSwitch}>
                  {ctaActionNames.ACTIVATEHEALTHVAULT}
                </Button>
              </Col>
            }
            {
              isFreeEdit &&
              <Col>
                <Button data-testid="cancel-action" type="primary"
                  onClick={(event: any): void => onButtonClick(event, 'CORP_EDIT')}>
                  {ctaActionNames.EDIT}
                </Button>
              </Col>
            }
            {
              !islocked && isDraft && canActivate(authFeatureConstants.NEW_ADMISSION) &&
              <Col>
                <Button data-testid="draft-delete-action" type="primary"
                  onClick={(event: any): void => onButtonClick(event, 'DRAFT_DELETE')}
                >
                  {ctaActionNames.DELETE}
                </Button>
              </Col>
            }
          </Row>
        )
      }
    </React.Fragment>
  );
};
export default InPatientListActions;
